import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Context } from '../components/Context'
import iconLeft from '../assets/icons/arrow_left.svg'
import iconRight from '../assets/icons/arrow_right.svg'
const Bee3D = window.Bee3D

export const EFFECT_TYPES = {
    ARC: 'arc',
    CAROUSEL: 'carousel',
    CLASSIC: 'classic',
    CONCAVE: 'concave',
    COVERFLOW: 'coverflow',
    CUBE: 'cube',
    SPIRAL_LEFT: 'spiral-left',
    SPIRAL_RIGHT: 'spiral-right',
    WAVE: 'wave',
}
class CoverFlow extends React.Component {
    static contextType = Context
    constructor(props) {
        super(props)
        this.state = {}
        this.ref = React.createRef()
    }

    componentDidMount() {
        this.slider = new Bee3D(this.ref.current, {
            effect: this.props.effect,
            listeners: {
                // <-- added here
                keys: true,
                touches: true,
                clicks: false,
                drag: true,
            },
            loop: {
                enabled: true,
            },
            navigation: {
                enabled: true,
                next: '.bee3D--nav__next',
                prev: '.bee3D--nav__prev',
            },
        })
    }

    render() {
        return (
            <div ref={this.ref} className="bee3D--parent cover-flow-container">
                {this.props.data.map((info, index) => {
                    return (
                        <section key={'slider-' + info.title} className="bee3D--slide">
                            <a
                                style={{ color: this.props.titleColor }}
                                className="slider-title"
                                href="#"
                                onClick={() => {
                                    if (this.props.onItemClick) {
                                        this.props.onItemClick(info, index)
                                    }
                                }}
                            >
                                <img style={{ width: '100%' }} src={info.cover} />
                                {info.title}
                                <br />
                                <span style={{ fontSize: 23 }}>{info.category}</span>
                            </a>
                        </section>
                    )
                })}
                <div className="cover-flow-slider-navigation">
                    <img className="bee3D--nav__prev" src={iconLeft} />
                    <img className="bee3D--nav__next" src={iconRight} />
                </div>
            </div>
        )
    }
}

CoverFlow.propTypes = {
    data: PropTypes.array,
    onItemClick: PropTypes.func,
}

export default CoverFlow
